import { render, staticRenderFns } from "./OurProducts.vue?vue&type=template&id=2a08a2cf&scoped=true&"
import script from "./OurProducts.vue?vue&type=script&lang=js&"
export * from "./OurProducts.vue?vue&type=script&lang=js&"
import style0 from "./OurProducts.vue?vue&type=style&index=0&id=2a08a2cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08a2cf",
  null
  
)

export default component.exports